import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './pdp-user-membership_types.2';

export function getUserMembership(variable: types.GetUserMembershipVariables, options?: GqlRequestOptions) {
  const query = 'query GetUserMembership($input: PdpUserBaseInfoInput) { pdp_user_base_info(input: $input) { pdp_user_membership { grade mileage_reward { rate amount additional_rate } } } }';
  return gql_request<types.GetUserMembership, types.GetUserMembershipVariables>('GetUserMembership', query, variable, { use_consumer: true, ...options });
}

